<template>
  <div class="container">
    <div class="banner-ads">
      <a :href="link" target="_blank">
        <figure v-if="img" class="img-area">
          <img :src="img" alt="" />
        </figure>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped>
.banner-ads {
  height: 100%;
  width: 100%;
  max-width: 100% !important;
  display: flex;
  justify-content: center;
  margin: 5px auto;
}
.banner-ads > div {
  border-radius: 10px;
  width: 80%;
  height: 100px;
}

.img-area {
  margin: 0px;
  height: 100%;
}
.img-area > img {
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
  object-fit: contain;
  width: 100%;
  height: 100%;
}
</style>